import Swal, { SweetAlertOptions } from 'sweetalert2';

const BASE: SweetAlertOptions = {
  reverseButtons: true,
  confirmButtonText: 'OK',
  cancelButtonText: 'Annuler',
};

export const SwalUtils = {

  success(title: string, text: string, options?: SweetAlertOptions) {
    return Swal.fire({
      ...BASE,
      icon: 'success',
      title,
      text,
      confirmButtonColor: '#16a34a',
      ...options,
    } as SweetAlertOptions);
  },

  apiError(err: any, fallback = 'Une erreur est survenue') {
    const msg = err?.error?.message || err?.message || fallback;
    return Swal.fire({
      ...BASE,
      icon: 'error',
      title: 'Erreur',
      text: msg,
      confirmButtonColor: '#dc2626',
    } as SweetAlertOptions);
  },

  error(title: string, text: string, options?: SweetAlertOptions) {
    return Swal.fire({
      ...BASE,
      icon: 'error',
      title,
      text,
      confirmButtonColor: '#dc2626',
      ...options,
    } as SweetAlertOptions);
  },

  warning(title: string, textOrHtml: string, isHtml = false, options?: SweetAlertOptions) {
    return Swal.fire({
      ...BASE,
      icon: 'warning',
      title,
      ...(isHtml ? { html: textOrHtml } : { text: textOrHtml }),
      confirmButtonColor: '#ea580c',
      ...options,
    } as SweetAlertOptions);
  },

  confirm(title: string, text: string, confirmButtonText: string, options?: SweetAlertOptions) {
    return Swal.fire({
      ...BASE,
      icon: 'question',
      title,
      text,
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
      confirmButtonText,
      ...options,
    } as SweetAlertOptions);
  },

  confirmGreen(title: string, text: string, confirmButtonText: string, options?: SweetAlertOptions) {
    return Swal.fire({
      ...BASE,
      icon: 'question',
      title,
      text,
      showCancelButton: true,
      confirmButtonColor: '#16a34a',
      cancelButtonColor: '#6b7280',
      confirmButtonText,
      ...options,
    } as SweetAlertOptions);
  },

  confirmDanger(title: string, text: string, confirmButtonText: string, options?: SweetAlertOptions) {
    return Swal.fire({
      ...BASE,
      icon: 'warning',
      title,
      text,
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
      confirmButtonText,
      ...options,
    } as SweetAlertOptions);
  },

  async confirmWithMotif(title: string, confirmButtonText: string): Promise<{ isConfirmed: boolean; motif: string }> {
    const result = await Swal.fire({
      ...BASE,
      icon: 'warning',
      title,
      input: 'textarea',
      inputLabel: 'Motif du rejet',
      inputPlaceholder: 'Saisir le motif...',
      inputAttributes: { rows: '4', style: 'resize: vertical;' },
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
      confirmButtonText,
    });
    return {
      isConfirmed: result.isConfirmed,
      motif: result.isConfirmed ? (result.value as string) : '',
    };
  },
};
